export const TIMEOUTS = {
  IDLE_POPUP_TIME: 60 * 1000 * 85,
  POPUP_COUNTDOWN_TIME: 60 * 1000 * 5,
  ONE_MIN: 1000 * 60,
  IDLE_TIMEOUT: 60 * 1000 * 90
};

export const domEvents = ["click"];